import React from 'react';
import { Button } from 'rsuite';
import LockIcon from '@material-ui/icons/Lock';
import styles from './PageBlocker.module.scss';

type PageBlockerProps = {
  id?: string;
  title?: string;
  subtitle?: string;
  buttonText?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
};

export const PageBlocker = ({ id, title, subtitle, buttonText, style, className, onClick }: PageBlockerProps) => {
  return (
    <div className={[styles['block-page'], className].join(' ')} style={style}>
      <LockIcon className={styles['lock-icon']} />
      <p className={styles.title}>{title}</p>
      <p className={styles.subtitle}>{subtitle}</p>
      <Button id={id} className={styles['btn-action']} onClick={onClick}>
        {buttonText}
      </Button>
    </div>
  );
};
